import "./DramaAndCharacters.module.css";
import Header from "@/reusable_sections/Header";
import DramaNarrativeExplorationFlow from "./sections/DramaNarrativeExplorationFlow";
import Footer from "@/reusable_sections/Footer";
export default function DramaAndCharactersPage() {
  return <div>
      <Header />
      <DramaNarrativeExplorationFlow />
      <Footer />
    </div>;
}